import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {AuthenticationService} from '../shared/authentication/authentication.service';

@Component({
  selector: 'gp-view-error',
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {

  public type: string;

  constructor(private authenticationService: AuthenticationService,
              private route: ActivatedRoute) {

  }

  public ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      this.type = params.type;
    });

    this.authenticationService.clearUser();
  }
}
